import React from 'react';
import Header from '../../components/Header';
import { useHistory } from "react-router-dom";
import './index.css';
import { BiWater, BiMapPin, BiCollapse, BiMap, BiSort, BiSortDown } from "react-icons/bi";
import { BsOctagonHalf } from "react-icons/bs";
import { FiClock } from "react-icons/fi";

export default function Importacao() {

    let history = useHistory();

    function irrigAnPorProp(e) {
        e.preventDefault();
        history.push('/irriganporprop');
    }

    function insAnPorOpe(e) {
        e.preventDefault();
        history.push('/insanporope');
    }

    function irrigDetPorLcto(e) {
        e.preventDefault();
        history.push('/insdetporope');
    }

    function efPorHora(e){
        e.preventDefault();
        history.push('/efporhora');
    }

    return (
        <div className="container-lg">
            <Header title="RELATÓRIOS DE IRRIGAÇÃO" />
            <div className="botoesrel">
                <div className="dropdown">
                    <button className="dropbtn"><BiWater /> Irrigação
                    </button>
                    <div className="dropdown-content">
                        <button
                            className="btn-rel btn btn-sm btn-success"
                            onClick={(e) => irrigAnPorProp(e)}>
                            <BiMapPin /> Analitico por Propriedade
                        </button>
                        <button
                            className="btn-rel btn btn-sm btn-success"
                            onClick={(e) => irrigDetPorLcto(e)}>
                            <BiSortDown /> Detalhado por Lançamentos
                        </button>
                    </div>

                </div>
            </div>
            <div className="botoesrel">
                <div className="dropdown">
                    <button className="dropbtn">
                        <BiCollapse /> Insumos
                    </button>
                    <div className="dropdown-content">
                        <button
                            className="btn-rel btn btn-sm btn-success"
                            onClick={(e) => insAnPorOpe(e)}
                        >
                            <BsOctagonHalf /> Analitico por Operação
                        </button>
                    </div>
                </div>
            </div>
            <div className="botoesrel">
                <div className="dropdown">
                    <button className="dropbtn"><BiMap /> Outorgas</button>
                    <div className="dropdown-content">
                        {/* <button className="btn-rel btn btn-sm btn-success">Analitico por Operação</button> */}
                        {/* <button class="btn-rel btn btn-sm btn-success">Analitico por Propriedade</button>
                    <button class="btn-rel btn btn-sm btn-success">Analitico por Propriedade</button> */}
                    </div>
                </div>
            </div>
            <div className="botoesrel">
                <div className="dropdown">
                    <button className="dropbtn"><BiSort /> Eficiência</button>
                    <div className="dropdown-content">
                        <button
                            className="btn-rel btn btn-sm btn-success"
                            onClick={(e) => efPorHora(e)}>
                            <FiClock /> Eficiencia por hora
                        </button>
                    </div>
                </div>
            </div>
        </div >
    )
}